import { create } from 'zustand';

/**
 * Section ids for the account modal — mirrors the tab set in `AccountModal`.
 * Declared here (not in the component) so any CTA can deep-link to a tab
 * without importing `AccountModal` and creating a store↔component cycle.
 */
export type AccountSection = 'profile' | 'email' | 'password' | 'passkeys' | 'invite' | 'danger';

interface AccountModalState {
  open: boolean;
  /** Tab the modal opens to. `null` → `AccountModal`'s default ('profile'). */
  section: AccountSection | null;
  openModal: (section?: AccountSection) => void;
  closeModal: () => void;
}

/**
 * Global open-state for the account modal. The modal itself is mounted once in
 * `RootLayout` (so it's available on every protected route regardless of the
 * sidebar/sheet mount state); any surface can deep-link a tab via `openModal`.
 * Mirrors the `useFeedbackStore` pattern.
 */
export const useAccountModalStore = create<AccountModalState>((set) => ({
  open: false,
  section: null,
  openModal: (section) => set({ open: true, section: section ?? null }),
  closeModal: () => set({ open: false, section: null }),
}));
